import LandingPageText from './landing-page-text';

<template><LandingPageText @campaign={{@campaign}} /></template>
